import { Favorite, CheckedFull, Close, History } from '@gympass/yoga-icons';

import { Summary } from 'pages/SessionHistory/types';

const historyResumeConfigs = (data: Summary) => [
  {
    key: 'totalSessions',
    title: 'SESSION.HISTORY.CP.BIGNUMBER.REGISTERED',
    amount: data.totalSessions,
    tooltip: 'SESSION.HISTORY.CP.TOOLTIP.REGISTERED',
  },
  {
    key: 'completedSessions',
    title: 'SESSION.HISTORY.CP.BIGNUMBER.COMPLETED',
    amount: data.completed?.regular,
    icon: CheckedFull,
    tooltip: 'SESSION.HISTORY.CP.TOOLTIP.COMPLETED',
    accepted: data.completed?.accepted,
  },
  {
    key: 'welcomeSessions',
    title: 'SESSION.HISTORY.CP.BIGNUMBER.WELCOME',
    amount: data.completed?.initial,
    icon: Favorite,
    tooltip: 'SESSION.HISTORY.CP.TOOLTIP.WELCOME',
  },
  {
    key: 'noShowSessions',
    title: 'SESSION.HISTORY.CP.BIGNUMBER.NOSHOW',
    amount: data.noShow,
    icon: Close,
    tooltip: 'SESSION.HISTORY.CP.TOOLTIP.NOSHOW',
  },
  {
    key: 'lateCancelSessions',
    title: 'SESSION.HISTORY.CP.BIGNUMBER.LATECANCEL',
    amount: data.lateCancel,
    icon: History,
    tooltip: 'SESSION.HISTORY.CP.TOOLTIP.LATECANCEL',
  },
];

export default historyResumeConfigs;
